
const creatorTorneoRutes = [
  // categoria calenario
  {
    path: 'reporte-creator/tfxsimple',
    component: () => import('../views/creator/torneo/calendar/SimpleCalendarPage.vue'),
    name: 'tfxsimple'
  },
  {
    path: 'reporte-creator/tfxlibertadores',
    component: () => import('../views/creator/torneo/calendar/LibertadoresCalendarPage.vue'),
    name: 'tfxlibertadores'
  },
  {
    path: 'reporte-creator/tfxeuropa',
    component: () => import('../views/creator/torneo/calendar/EuroCalendarPage.vue'),
    name: 'tfxeuropa'
  },
  {
    path: 'reporte-creator/tfxchampions',
    component: () => import('../views/creator/torneo/calendar/ChampionsCalendarPage.vue'),
    name: 'tfxchampions'
  },
  {
    path: 'reporte-creator/tfxcienciano',
    component: () => import('../views/creator/torneo/calendar/CiencianoCalendarPage.vue'),
    name: 'tfxcienciano'
  },
  {
    path: 'reporte-creator/tfxafrica',
    component: () => import('../views/creator/torneo/calendar/SimpleCalendarPage.vue'),
    name: 'tfxafrica'
  },
  {
    path: 'reporte-creator/tfxasia',
    component: () => import('../views/creator/torneo/calendar/SimpleCalendarPage.vue'),
    name: 'tfxasia'
  },
  // categoria fixture
  {
    path: 'reporte-creator/fxmsimple',
    component: () => import('../views/creator/torneo/fixture/SimpleFixturePage.vue'),
    name: 'fxmsimple'
  },
  {
    path: 'reporte-creator/fxmmundial',
    component: () => import('../views/creator/torneo/fixture/MundialFixturePage.vue'),
    name: 'fxmmundial'
  },
  {
    path: 'reporte-creator/fxmamerica',
    component: () => import('../views/creator/torneo/fixture/AmericaFixturePage.vue'),
    name: 'fxmamerica'
  },
  {
    path: 'reporte-creator/fxmcolumns',
    component: () => import('../views/creator/torneo/fixture/ColumnaFixturePage.vue'),
    name: 'fxmcolumns'
  },
  // categoria resultados
  {
    path: 'reporte-creator/rssimple',
    component: () => import('../views/creator/torneo/resultados/SimpleResultadosPage.vue'),
    name: 'resimple'
  },
  {
    path: 'reporte-creator/rslibertadores',
    component: () => import('../views/creator/torneo/resultados/LibertadoresResultadosPage.vue'),
    name: 'relibertadores'
  },
  {
    path: 'reporte-creator/rschampions',
    component: () => import('../views/creator/torneo/resultados/ChampionsResultadosPage.vue'),
    name: 'rechampions'
  },
  {
    path: 'reporte-creator/rscienciano',
    component: () => import('../views/creator/torneo/resultados/CiencianoResultadosPage.vue'),
    name: 'recienciano'
  },
  {
    path: 'reporte-creator/rseuro',
    component: () => import('../views/creator/torneo/resultados/EuroResultadosPage.vue'),
    name: 'reeuro'
  },
  {
    path: 'reporte-creator/rsfxsimple',
    component: () => import('../views/creator/torneo/resultados/SimpleFixtureResultadosPage.vue'),
    name: 'refxsimple'
  },
  {
    path: 'reporte-creator/rsfxmundial',
    component: () => import('../views/creator/torneo/resultados/MundialFixtureResultadosPage.vue'),
    name: 'refxmundial'
  },
  // =================================
  // PANTALLAS PARA CATEGORIA TABLA
  // ===================================
  {
    path: 'reporte-creator/tbsimple',
    component: () => import('../views/creator/torneo/tabla/SimpleTablaPage.vue'),
    name: 'tbsimple'
  },
  {
    path: 'reporte-creator/tbfilas',
    component: () => import('../views/creator/torneo/tabla/FilaTablaPage.vue'),
    name: 'tbfilas'
  },
  
  {
    path: 'reporte-creator/tbcienciano',
    component: () => import('../views/creator/torneo/tabla/CiencianoTablaPage.vue'),
    name: 'tbcienciano'
  },
  {
    path: 'reporte-creator/tbcopamarica',
    component: () => import('../views/creator/torneo/tabla/AmericaTablaPage.vue'),
    name: 'tbamerica'
  },
  {
    path: 'reporte-creator/tbresltado',
    component: () => import('../views/creator/torneo/tabla/DarkTablaPage.vue'),
    name: 'tbresltado'
  },
  // =================================
  // PANTALLAS PARA TARJETAS Y SANCIONES
  // ===================================
  {
    path: 'reporte-creator/tstarjetaspdf',
    component: () => import('../views/creator/torneo/tarjetas/SancionesPdfPage.vue'),
    name: 'tstarjetaspdf'
  },
  {
    path: 'reporte-creator/tstarjetassimple',
    component: () => import('../views/creator/torneo/tarjetas/SimpleTarjetasTorneoPage.vue'),
    name: 'tstarjetassimple'
  },
  {
    path: 'reporte-creator/tstarjetasstandar',
    component: () => import('../views/creator/torneo/tarjetas/StandarTarjetasTorneoPage.vue'),
    name: 'tstarjetasstandar'
  },
  // =================================
  // PANTALLAS PARA REPORTE POSTER
  // ===================================
  {
    path: 'reporte-creator/ptsimple',
    component: () => import('../views/creator/torneo/poster/SimplePosterPage.vue'),
    name: 'ptsimple'
  },
  {
    path: 'reporte-creator/ptamerica',
    component: () => import('../views/creator/torneo/poster/AmericaPosterPage.vue'),
    name: 'ptamerica'
  },
  // =================================
  // PANTALLAS PARA GOLEADORES TORNEO
  // ===================================
  {
    path: 'reporte-creator/gltsimple',
    component: () => import('../views/creator/torneo/goleadores/SimpleGoleadoresPage.vue'),
    name: 'gltsimple'
  },
  {
    path: 'reporte-creator/gltstandar',
    component: () => import('../views/creator/torneo/goleadores/StandarGoleadoresPage.vue'),
    name: 'gltstandar'
  },
  {
    path: 'reporte-creator/gltlibertadores',
    component: () => import('../views/creator/torneo/goleadores/LibertadoresGoleadoresPage.vue'),
    name: 'gltlibertadores'
  },
  
]

export default creatorTorneoRutes
